import { render, staticRenderFns } from "./Glossary.vue?vue&type=template&id=5b247d54&scoped=true"
import script from "./Glossary.vue?vue&type=script&lang=js"
export * from "./Glossary.vue?vue&type=script&lang=js"
import style0 from "./Glossary.vue?vue&type=style&index=0&id=5b247d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b247d54",
  null
  
)

export default component.exports